import { FC } from 'react';
import { PartialRecord } from '@tsl-frontend/tsl-utilities';

import { BadgeCode, BadgeStatus } from '../types';

import {
    BadgeAvailable,
    BadgeFirstLo,
    BadgeLocked,
    BadgeProgrammeHalfway,
    BadgeProgrammeEnd,
    DialogBadgeAvailable,
    DialogBadgeLocked,
    firstLoDialogBadge,
    programmeEndDialogBadge,
    programmeHalfwayDialogBadge,
} from '@assets/dashboard';

const badgeImageMapping = {
    [BadgeStatus.BADGE_LOCKED]: BadgeLocked,
    [BadgeStatus.BADGE_AVAILABLE]: BadgeAvailable,
};

const badgeDialogImageMapping = {
    [BadgeStatus.BADGE_LOCKED]: DialogBadgeLocked,
    [BadgeStatus.BADGE_AVAILABLE]: DialogBadgeAvailable,
};

const claimedBadgeImageMapping = {
    [BadgeCode.FIRST_LO]: BadgeFirstLo,
    [BadgeCode.PROGRAMME_HALFWAY]: BadgeProgrammeHalfway,
    [BadgeCode.PROGRAMME_END]: BadgeProgrammeEnd,
};

export const claimedBadgeDialogImageMapping = {
    [BadgeCode.FIRST_LO]: firstLoDialogBadge,
    [BadgeCode.PROGRAMME_HALFWAY]: programmeHalfwayDialogBadge,
    [BadgeCode.PROGRAMME_END]: programmeEndDialogBadge,
};

interface ImageMapping {
    badge: PartialRecord<BadgeStatus, FC>;
    dialog: PartialRecord<BadgeStatus, FC>;
}

export const getBadgeImages = (code: BadgeCode): ImageMapping => {
    return {
        badge: {
            ...badgeImageMapping,
            [BadgeStatus.BADGE_CLAIMED]: claimedBadgeImageMapping[code],
        },
        dialog: {
            ...badgeDialogImageMapping,
        },
    };
};
